import { normalizarClave } from "./comun";

// Campos del catálogo por los que se intenta el empate, en orden de preferencia. El código
// del proveedor manda sobre la descripción cuando el documento lo trae (PISA imprime 4000171,
// que es el NoIdentificacion del CFDI y vive en relaciones[].codigo). descripcionInsumo es la
// descripción del insumo maestro cuando el renglón es una relación de proveedor.
const CAMPOS_EMPATE = ["codigo", "clave", "codigoBarras", "descripcion", "descripcionInsumo"];

/**
 * Vuelca en los renglones del Form los lotes/cantidades que produjo un lector (PDF o Excel).
 * No crea renglones: sólo llena `lotes` y `recibir` de los que ya están.
 *
 * @param formRef        ref del Form de antd con el Form.List `insumos`
 * @param todasInsumos   catálogo de la pantalla (insumos y relaciones, con _id)
 * @param productsByDesc Map<clave, { lotes: [{numero, caducidad, cantidad}], cantidadLinea }>
 * @returns {{ matched: number, total: number, entradasUsadas: Set<object> }}
 *   entradasUsadas son los objetos del Map que empataron con algún renglón, para que el
 *   llamador pueda reportar los que no (varias claves pueden apuntar a la misma entrada).
 */
export function aplicarLotesAlForm(formRef, todasInsumos, productsByDesc) {
  const insumos = formRef.current?.getFieldValue("insumos") || [];
  const entradasUsadas = new Set();
  let matched = 0;

  // Índice normalizado (minúsculas, sin acentos, espacios colapsados) de lo que devolvió el
  // lector, para que un acento o un espacio doble entre el documento y el catálogo no rompa
  // el empate. Gana la primera clave, como ya hacía Fanasa.js:64.
  const indice = new Map();
  for (const [clave, datos] of productsByDesc) {
    const normalizada = normalizarClave(clave);
    if (normalizada && !indice.has(normalizada)) indice.set(normalizada, datos);
  }

  for (let i = 0; i < insumos.length; i++) {
    const insumoInfo = (todasInsumos || []).find((x) => x._id === insumos[i].insumoId);
    if (!insumoInfo) continue;

    let prodData = null;
    for (const campo of CAMPOS_EMPATE) {
      const llave = normalizarClave(insumoInfo[campo]);
      if (llave && indice.has(llave)) {
        prodData = indice.get(llave);
        break;
      }
    }
    if (!prodData) continue;

    if (prodData.lotes.length > 0) {
      insumos[i].lotes = prodData.lotes.map((l) => ({
        numero: l.numero,
        caducidad: l.caducidad,
        cantidad: l.cantidad,
      }));
      const total = prodData.lotes.reduce((s, l) => s + (Number(l.cantidad) || 0), 0);
      if (total > 0) insumos[i].recibir = total;
    } else if (prodData.cantidadLinea != null) {
      insumos[i].recibir = prodData.cantidadLinea;
    } else {
      continue;
    }

    entradasUsadas.add(prodData);
    matched++;
  }

  if (matched > 0) formRef.current.setFieldsValue({ insumos });

  return { matched, total: insumos.length, entradasUsadas };
}
